import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";

import { AuthProvider } from "./Components/auth/AuthContext";
import PrivateRoute from "./Components/auth/PrivateRoute";

import Login from "./Pages/LoginPage";
import DashboardLayout from "./Layout/DashboardLayout";
import DashboardHome from "./Pages/DashboardHome";

import GroupMaster from "./Components/Masters/GroupMaster";
import RestaurantSubscriptionMaster from "./Components/Masters/RestaurantSubscriptionMaster";
import DepartmentMaster from "./Components/Masters/DepartmentMaster";
import DesignationMaster from "./Components/Masters/DesignationMaster";
import EmployeeMaster from "./Components/Masters/EmployeeMaster";
import RestaurantMaster from "./Components/Masters/RestaurantMaster";

import NewUserRegister from "./Components/OutletComponents/NewUserRegister";
import ShiftMaster from "./Components/OutletComponents/ShiftMaster";
import EmployeeProfile from "./Components/OutletComponents/EmployeeProfile";
import EmployeeTransferHistory from "./Components/OutletComponents/EmployeeTransferHistory";

import UserTypeMaster from "./Components/SystemUserComponents/UserTypeMaster";
import SysNewUserRegister from "./Components/SystemUserComponents/SysNewUserRegister";
import UserMaster from "./Components/SystemUserComponents/UserMaster";
import UserRole from "./Components/SystemUserComponents/UserRole";
import ModuleMaster from "./Components/SystemUserComponents/ModuleMaster";
import RoleMaster from "./Components/SystemUserComponents/RoleMaster";

import AtteLogTodayPrecentByGroup from "./Components/attendanceLogReports/AtteLogTodayPrecentByGroup";
import DailyAttendanceReport from "./Components/ReportsComponents/ByGroup/DailyAttendanceReport";
import PeridicAttendanceReport from "./Components/ReportsComponents/ByGroup/PeridicAttendanceReport";
import DailyReportByRestaurant from "./Components/ReportsComponents/ByRestaunent/DailyReportByRestaurant";
import PeriodicReportByRest from "./Components/ReportsComponents/ByRestaunent/PeriodicReportByRest";
import AttendanceExceptionReport from "./Components/RestaurentComponent/AttendanceExceptionReport";
import AttendanceManagerByGroup from "./Components/RestaurentComponent/AttendanceManagerByGroup";
import ManagerAttendanceControl from "./Components/ManagerComponent/ManagerAttendanceControl";
import LeavingEmployeeReport from "./Components/ReportsComponents/ByGroup/LeavingEmployeeReport";
import AttendancePolicy from "./Components/AttendancePolicyMaster/AttendancePolicy";
import GenerateAutoMonthlySummary from "./Components/ReportsComponents/ByGroup/GenerateAutoMonthlySummary";
import GenerateManualMonthlySummary from "./Components/ReportsComponents/ByGroup/GenerateManualMonthlySummary";
import MonthlyAttendanceSummaryReport from "./Components/ReportsComponents/ByGroup/MonthlyAttendanceSummaryReport";
import SalaryCalculation from "./Pages/SalaryCalculation";
import AttendancelogCreateManually from "./Components/SystemUserComponents/AttendancelogCreateManually";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>

          {/* ✅ PUBLIC */}
          <Route path="/login" element={<Login />} />

          {/* ✅ MAIN LAYOUT */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <DashboardLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />

            {/* ================= DASHBOARD ================= */}
            <Route
              path="dashboard"
              element={
                <PrivateRoute moduleName="Dashbord">
                  <DashboardHome />
                </PrivateRoute>
              }
            />

            {/* ================= ATTENDANCE ================= */}
            <Route
              path="attendance/TodayAttendance"
              element={
                <PrivateRoute moduleName="Attendance">
                  <AtteLogTodayPrecentByGroup />
                </PrivateRoute>
              }
            />

            <Route
              path="attendance/CreateManually"
              element={
                <PrivateRoute moduleName="Attendance">
                  {/* <AttendancelogCreateManually /> */}
                  <AttendancelogCreateManually/>
                </PrivateRoute>
              }
            />

            {/* ================= MASTERS ================= */}
            <Route path="masters">

              {/* 🔐 SYSTEM + ADMIN ONLY */}
              <Route
                element={
                  <PrivateRoute allowedRoles={["Super Admin", "System Admin"]}>
                    <Outlet />
                  </PrivateRoute>
                }
              >

                <Route index element={<Navigate to="GroupMaster" replace />} />

                <Route
                  path="GroupMaster"
                  element={
                    <PrivateRoute moduleName="Group Master">
                      <GroupMaster />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="RestaurantMaster"
                  element={
                    <PrivateRoute moduleName="Restaurant Master">
                      <RestaurantMaster />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="RestaurantSubscriptionMaster"
                  element={
                    <PrivateRoute moduleName="Restaurant Subscription">
                      <RestaurantSubscriptionMaster />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="UserTypeMaster"
                  element={
                    <PrivateRoute moduleName="User Type Master">
                      <UserTypeMaster />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="ModuleMaster"
                  element={
                    <PrivateRoute moduleName="Module Master">
                      <ModuleMaster />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="RoleMaster"
                  element={
                    <PrivateRoute moduleName="Role Master" accessType="write">
                      <RoleMaster />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="UserMaster"
                  element={
                    <PrivateRoute moduleName="User Master">
                      <UserMaster />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="UserRole"
                  element={
                    <PrivateRoute moduleName="User Role">
                      <UserRole />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="SysNewUserRegister"
                  element={
                    <PrivateRoute moduleName="User Master">
                      <SysNewUserRegister />
                    </PrivateRoute>
                  }
                />

                {/* ================= OUTLET ================= */}

                <Route
                  path="NewUserRegister"
                  element={
                    <PrivateRoute moduleName="User Master">
                      <NewUserRegister />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="DepartmentMaster"
                  element={
                    <PrivateRoute moduleName="Department Master">
                      <DepartmentMaster />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="DesignationMaster"
                  element={
                    <PrivateRoute moduleName="Designation Master">
                      <DesignationMaster />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="employees"
                  element={
                    <PrivateRoute moduleName="Employee Master">
                      <EmployeeMaster />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="attendance/ShiftMaster"
                  element={
                    <PrivateRoute moduleName="Shift Master">
                      <ShiftMaster />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="attendance/EmployeeProfile"
                  element={
                    <PrivateRoute moduleName="Employee Profile">
                      <EmployeeProfile />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="attendance/EmployeeTransferHistory"
                  element={
                    <PrivateRoute moduleName="Employee Transfer">
                      <EmployeeTransferHistory />
                    </PrivateRoute>
                  }
                />

              </Route>
            </Route>

            <Route path="AttendancePolicy">

              <Route
                element={
                  <PrivateRoute allowedRoles={["Restaurant Admin"]}>
                    <Outlet />
                  </PrivateRoute>
                }
              >

                {/* ✅ Default redirect */}
                <Route index element={<Navigate to="Attendance-Policy" replace />} />

                {/* ✅ Module 26 */}
                <Route
                  path="Attendance-Policy"
                  element={
                    <PrivateRoute moduleName="Attendance Policy">
                      <AttendancePolicy />
                    </PrivateRoute>
                  }
                />

              </Route>


            </Route>

            {/* ================= REPORTS ================= */}
            <Route path="reports">

              <Route
                element={
                  <PrivateRoute allowedRoles={["Super Admin", "System Admin", "Restaurant Admin"]}>
                    <Outlet />
                  </PrivateRoute>
                }
              >

                {/* ✅ Default redirect */}
                <Route index element={<Navigate to="daily-attendance-group" replace />} />

                {/* ✅ Module 18 */}
                <Route
                  path="daily-attendance-group"
                  element={
                    <PrivateRoute moduleName="Daily Attendance Report By Group">
                      <DailyAttendanceReport />
                    </PrivateRoute>
                  }
                />

                {/* ✅ Module 19 */}
                <Route
                  path="daily-attendance-periodic"
                  element={
                    <PrivateRoute moduleName="Daily Attendance Report By Group Peridic">
                      <PeridicAttendanceReport />
                    </PrivateRoute>
                  }
                />
                {/*✅ Module 20 */}
                <Route
                  path="daily-report-by-restaurant"
                  element={
                    <PrivateRoute moduleName="Daily Attendance Report By Restaurant">
                      <DailyReportByRestaurant />
                    </PrivateRoute>
                  }
                />
                {/* ✅ Module 21 */}
                <Route
                  path="periodic-report-by-restaurant"
                  element={
                    <PrivateRoute moduleName="Periodic Attendance Report By Rest">
                      <PeriodicReportByRest />
                    </PrivateRoute>
                  }
                />
                {/* ✅ Module 25 */}
                <Route
                  path="Employee-Leaving-Report"
                  element={
                    <PrivateRoute moduleName="Employee Leaving Report Group">
                      <LeavingEmployeeReport />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="Monthly-Attendance-Summary-Report"
                  element={
                    <PrivateRoute moduleName="Monthly Attendance Summary Report">
                      <MonthlyAttendanceSummaryReport />
                    </PrivateRoute>
                  }
                />
              


              </Route>



            </Route>

            <Route path="transaction">

              <Route
                element={
                  <PrivateRoute allowedRoles={["Restaurant Admin"]}>
                    <Outlet />
                  </PrivateRoute>
                }
              >

                {/* ✅ Default redirect */}
                <Route index element={<Navigate to="Attendance-ExceptionReport" replace />} />

                {/* ✅ Module 22 */}
                <Route
                  path="Attendance-ExceptionReport"
                  element={
                    <PrivateRoute moduleName="Attendance Exception Report Restaurant">
                      <AttendanceExceptionReport />
                    </PrivateRoute>
                  }
                />
              </Route>
              {/* ✅ Module 23 */}
              <Route
                path="Attendance-ManagerByGroup"
                element={
                  <PrivateRoute moduleName="Attendance Manager By Group">
                    <AttendanceManagerByGroup />
                  </PrivateRoute>
                }
              />
              <Route
                path="Bulk-Attendance-Manager"
                element={
                  <PrivateRoute moduleName="Bulk Attendance Manager">
                    <ManagerAttendanceControl />
                  </PrivateRoute>
                }
              />
              {/* ✅ Module 27 */}
              <Route
                path="Generate-Auto-Monthly-Summary"
                element={
                  <PrivateRoute moduleName="Generate Auto Monthly Summary">
                    <GenerateAutoMonthlySummary />
                  </PrivateRoute>
                }
              />
              <Route
                path="Generate-Manual-Monthly-Summary"
                element={
                  <PrivateRoute moduleName="Generate Manual Monthly Summary">
                    <GenerateManualMonthlySummary />
                  </PrivateRoute>
                }
              />
              <Route
                path="Salary-Calculation"
                element={
                  <PrivateRoute moduleName="Salary Calculation">
                    <SalaryCalculation />
                  </PrivateRoute>
                }
              />


            </Route>


          </Route>



          {/* ❌ UNAUTHORIZED PAGE */}
          <Route path="/unauthorized" element={<h2>Access Denied</h2>} />

          {/* ❌ FALLBACK */}
          <Route path="*" element={<Navigate to="/login" replace />} />

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;